import classNames from 'classnames';
import { useWindowSize } from 'usehooks-ts';

const STEPS = [
  {
    title: 'Step 1',
    subTitle: 'Select Tokens',
    description: (
      <>
        <span>Select up to 5 Tokens.</span>
        <br />
        <span>If there is a Coingecko feed, it is fair game!</span>
      </>
    ),
  },
  {
    title: 'Step 2',
    subTitle: 'Race Settings',
    description: (
      <>
        <span>Define the structure of your race by setting</span>
        <br />

        <span>1. Duration (1 to 24 hours)</span>
        <br />
        <span>2. Race Start,</span>
        <br />
        <span>3. how long bets will be accepted.</span>

        <p className="mt-3">Tailor these rules to create a fair and thrilling competition that suits your strategy.</p>
      </>
    ),
  },
  {
    title: 'Step 3',
    subTitle: 'Define Victory Metric & Edge',
    description: (
      <p>
        Fine-tune your race dynamics by customizing how token performance is evaluated. Allocate USDC to your race pool
        and distribute funds across the selected tokens.
      </p>
    ),
  },
];

const StepCard = ({
  step,
  currentStep,
  title,
  subTitle,
  children,
}: {
  step: number;
  title?: string;
  currentStep: number;
  subTitle?: string;
  children?: React.ReactNode;
}) => {
  const isActiveStep = step === currentStep;

  return (
    <div
      className={classNames('space-y-3 rounded-3xl border border-[#282133] px-6 py-4', {
        'bg-[#291946]': isActiveStep,
        'bg-[#10091C]': !isActiveStep,
      })}
    >
      <div
        className={classNames('text-2xl font-bold', {
          'text-[#6F6C90]': step > currentStep,
        })}
      >
        {title}
      </div>

      <div className="h-[1px] w-full bg-white/40" />

      <div className="text-[15px] font-medium">{subTitle}</div>

      <div className="text-xs text-[#9C9C9C]">{children}</div>
    </div>
  );
};

const StepCards = ({ currentStep }: { currentStep: number }) => {
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const stepsToRender = isMobile ? [STEPS[currentStep - 1]] : STEPS;

  return (
    <div className="space-y-4">
      {stepsToRender.map((step, idx) => {
        const stepNumber = isMobile ? currentStep : idx + 1;
        return (
          <StepCard key={idx} step={stepNumber} currentStep={currentStep} subTitle={step.subTitle} title={step.title}>
            {step.description}
          </StepCard>
        );
      })}
    </div>
  );
};

export default StepCards;
